import { render } from "./invoices.vue?vue&type=template&id=972eef88&scoped=true"
import script from "./invoices.vue?vue&type=script&lang=js"
export * from "./invoices.vue?vue&type=script&lang=js"

import "./invoices.vue?vue&type=style&index=0&id=972eef88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972eef88"]])

export default __exports__